import { zodResolver } from "@hookform/resolvers/zod";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Placeholder,
} from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import PhoneInput from "react-phone-input-2";
import Loader from "../../../../components/Common/Loader";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import {
  ESSENTAILLIST,
  HOTELADMIN,
  HOTELCREATE,
  HOTELDETAILS,
  HOTELSTORESETTING,
  HOTELUPDATE,
  PINLISTAPI,
  ROOMESSENTAILLIST,
} from "../../../../services/ApiCalls";
import Select from "react-select";
import GoogleAutocomplete from "../../../../components/Common/GoogleAutoComplete";
import { Country, State, City } from "country-state-city";
import fileUploader from "../../../../utilities/fileUploader";
import Loading from "../../../../components/Common/Loading";
import { useTranslation } from "react-i18next";
import multipleFileUploader from "../../../../utilities/multipleFileUploader";
const schema = z.object({
  hotelName: z.string().min(1, { message: "Hotel Name is required" }),
  address: z.string().min(1, { message: "Address is required" }),
  country: z.string().min(1, { message: "Country is required" }),
  state: z.string().min(1, { message: "State is required" }),
  city: z.string().min(1, { message: "City is required" }),
  totalRoom: z
    .number({ invalid_type_error: "Total rooms must be a number" })
    .min(0, { message: "Total rooms cannot be negative" }),
  // price: z
  //   .number({ invalid_type_error: "Price must be a number" })
  //   .min(0, { message: "Price cannot be negative" }),
  // type: z.string().min(1, { message: "Type is required" }),
  hotelImages: z
    .array(z.string())
    .min(1, { message: "At least one image is required" }),
  mobileNumber: z
    .string()
    .min(7, { message: "Mobile number is required" })
    .regex(/^[0-9]+$/, { message: "Only numbers allowed" }),
  description: z.string().optional(),
  email: z.string().email({ message: "Invalid email address" }),
  status: z.boolean(),
  countryCode: z.string().optional(),
  availability: z.string().min(1, { message: "Availabilty is required" }),
  amenities: z.array(z.string()).optional(),

  // checkInTime: z.string().optional(),
  // checkOutTime: z.string().optional(),
  highLight: z
    .array(
      z.object({
        type: z.string(),
        text: z.string().min(1, "Text is required"),
      })
    )
    .optional(),
});

const AddEditHotel = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const [loader, setLoader] = useState(false);
  const [highlights, setHighlights] = useState([]);
  const [hotelData, setHotelData] = useState();
  const [hotelAdmins, setHotelAdmins] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hotelAmenities, setHotelAmenities] = useState([]);
  const [roomAmenities, setRoomAmenities] = useState([]);
  const [hotelAdminData, setHotelAdminData] = useState([]);
  const [imgloader, setImgLoader] = useState(false);
  const [pinListData, setPinListData] = useState();
  const [imagePreview, setImagePreview] = useState();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      hotelName: "",
      totalRoom: "",
      country: "",
      state: "",
      city: "",
      address: "",
      mobileNumber: "",
      description: "",
      email: "",
      status: false,
      countryCode: "",
      availability: "",
      amenities: [],
      pinStatus: {},
      checkInTime: "",
      checkOutTime: "",
      type: "",
      price: 0,
      highLight: []
    },
  });


  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "highLight",
  });


  useEffect(() => {
    if (fields?.length === 0) {
      append({ type: "", text: "" });
    }
  }, [fields, append]);


  const selectedTypes = fields
    .map((item, idx) => watch(`highlights.${idx}.type`))
    ?.filter(Boolean);


  const getAmenityData = catchAsync(async () => {
    const [roomRes, hotelRes, hotelStoreRes] = await Promise.all([
      ROOMESSENTAILLIST({ limit: 100, page: 1, status: "Active" }),
      ESSENTAILLIST({ limit: 100, page: 1, status: "Active" }),
      HOTELSTORESETTING({}),
    ]);

    checkResponse({ res: roomRes, setData: setRoomAmenities });
    checkResponse({ res: hotelRes, setData: setHotelAmenities });
    checkResponse({ res: hotelStoreRes, setData: setHighlights });
    // checkResponse({ res: hotelAdminRes, setData: setHotelAdminData });
    // checkResponse({ res: pinRes, setData: setPinListData });
  });

  const submitHandler = catchAsync(async (data) => {

    const body = {
      ...data,
      displayPrice: {
        price: data?.price,
        type: data?.type
      },
      status: data.status ? "Active" : "Inactive",
      hotelImages: data.hotelImages?.map((ele) => ele?._id ?? ele), // already array of IDs
      totalRoom: Number(data?.totalRoom),
      location: {
        type: "Point",
        coordinates: [Number(watch("lng")), Number(watch("lat"))],
      },
      ...(id && { _id: id }),
    };
    if(!id)
    {
      delete body['status']
    }

    const res = await (id ? HOTELUPDATE(body) : HOTELCREATE(body));
    const success = checkResponse({ res, showSuccess: true });
    if (success) navigate(`/hotel?page=${page}`);
  });

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await HOTELDETAILS(id);

    const success = checkResponse({ res, setData: setHotelData, setLoader });
    if (success && res?.data?.data) {
      const data = res.data.data;
      setImagePreviews(data?.hotelImages || []);
      console.log(data.status,"dsssssss")
      reset({
        hotelName: data.hotelName || "",
        address: data.address || "",
        mobileNumber: data.mobileNumber || "",
        description: data.description || "",
        country: data?.country || "",
        state: data?.state || "",
        city: data?.city || "",
        availability: data?.availability || "",
        totalRoom: data?.totalRoom?.toString() || "",
        email: data.email || "",
        status: data.status?.toLowerCase() === "active",
        countryCode: data.countryCode?.replace("+", "") || "",
        lat: data.location?.coordinates?.[1] || "",
        lng: data.location?.coordinates?.[0] || "",
        checkInTime: data?.checkInTime || "",
        checkOutTime: data?.checkOutTime || "",
        type: data?.displayPrice?.type || "",
        price: data?.displayPrice?.price || "",
        checkOutTime: data?.checkOutTime || "",
        // userId: data.userId?._id || "",
        amenities: data.amenities?.map((a) => a._id) || [],
        hotelImages: data?.hotelImages?.map((ele) => ele?._id) || [],
        // pinStatus: data.pinStatus ? JSON.stringify(data.pinStatus) : "",
      });
      if (Array.isArray(data.highLight) && data.highLight.length > 0) {
        replace(
          data.highLight.map((item) => ({
            type: item.type,
            text: item.text,
          }))
        );
      } else {
        replace([{ type: "", text: "" }]);
      }
    }
  }, setLoader);

  useEffect(() => {
    getAmenityData();
    if (id) getData();
  }, [id]);

  const addressChangeHandler = (address) => {
    setValue("address", address?.address, { shouldValidate: true });
    setValue("lat", address?.lat, { shouldValidate: true });
    setValue("lng", address?.lng, { shouldValidate: true });
  };

  const handleCheckbox = (name, value, checked) => {
    const currentValues = watch(name) || [];
    if (checked) {
      setValue(name, [...currentValues, value]);
    } else {
      setValue(
        name,
        currentValues.filter((item) => item !== value)
      );
    }
  };



  const countryOptions = Country.getAllCountries().filter(country =>
 ["India", "Thailand", "Vietnam"].includes(country.name)).map((c) => ({
    value: c.name,
    label: c.name,
    isDisabled: !["India", "Thailand", "Vietnam"].includes(c.name)
  }));

  const stateOptions = (countryName) =>
    State.getStatesOfCountry(
      Country.getAllCountries().find((c) => c.name === countryName)?.isoCode
    ).map((s) => ({
      value: s.name,
      label: s.name,
    }));

  const cityOptions = (countryName, stateName) => {
    const country = Country.getAllCountries().find(
      (c) => c.name === countryName
    );
    const state = State.getStatesOfCountry(country?.isoCode).find(
      (s) => s.name === stateName
    );
    return City.getCitiesOfState(country?.isoCode, state?.isoCode).map(
      (ci) => ({
        value: ci.name,
        label: ci.name,
      })
    );
  };

  const [imagePreviews, setImagePreviews] = useState([]);

  const handleImageChange = catchAsync(async (e) => {
    setImgLoader(true);

    const files = Array.from(e.target.files);
    for (let file of files) {
      const res = await multipleFileUploader(file);

      if (Array.isArray(res)) {
        const currentIds = watch("hotelImages") || [];
        const newIds = res.map((img) => img._id);
        setValue("hotelImages", [...currentIds, ...newIds], {
          shouldValidate: true,
        });
        setImagePreviews((prev) => [...prev, ...res]);
      }
    }

    setImgLoader(false);
  });

  const handleRemoveImage = (index) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== index));
    const currentIds = watch("hotelImages") || [];
    const updatedIds = currentIds.filter((_, i) => i !== index);

    setValue("hotelImages", updatedIds, { shouldValidate: true });
  };


  console.log("eeeeee", errors);

  return (
    <>
      {loader && <Loader />}
      <section className="addPromo position-relative py-3">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={`/hotel?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id
                    ? t("manageHotel.editHotel")
                    : t("manageHotel.addNewHotel")}
                </h4>
              </div>
            </Col>

            <Col lg="12">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.hotelName")}</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("hotelName")}
                      />
                      {errors?.hotelName && (
                        <p className="text-danger">
                          {errors.hotelName.message}
                        </p>
                      )}
                    </Col>


                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.totalRoom")}</label>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        {...register("totalRoom", {
                          valueAsNumber: true,
                          min: 0,
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0;
                        }}
                      />
                      {errors?.totalRoom && (
                        <p className="text-danger">
                          {errors.totalRoom.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.country")}</label>
                      <Controller
                        control={control}
                        name="country"
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={countryOptions}
                            value={countryOptions.find(
                              (c) => c.value === field.value
                            )}
                            onChange={(option) => {
                              console.log(option)
                              setValue("country", option.value, {
                                shouldValidate: true,
                              });
                              setValue("state", "");
                              setValue("city", "");
                            }}
                          />
                        )}
                      />
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.province")} </label>

                      <Controller
                        control={control}
                        name="state"
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={stateOptions(watch("country"))}
                            value={stateOptions(watch("country")).find(
                              (s) => s.value === field.value
                            )}
                            onChange={(option) => {
                              setValue("state", option.value, {
                                shouldValidate: true,
                              });
                              setValue("city", "");
                            }}
                          />
                        )}
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.city")}</label>
                      <Controller
                        control={control}
                        name="city"
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={cityOptions(
                              watch("country"),
                              watch("state")
                            )}
                            value={cityOptions(
                              watch("country"),
                              watch("state")
                            ).find((ci) => ci.value === field.value)}
                            onChange={(option) =>
                              setValue("city", option.value, {
                                shouldValidate: true,
                              })
                            }
                          />
                        )}
                      />
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <label>{t("manageHotel.address")}</label>
                      <GoogleAutocomplete
                        lat={watch("lat")}
                        lng={watch("lng")}
                        name={"address"}
                        address={watch("address")}
                        onChange={addressChangeHandler}
                      />
                      {errors?.address && (
                        <p className="text-danger">
                          {errors?.address?.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <label>{t("manageHotel.phone")}</label>
                      <Controller
                        control={control}
                        name="mobileNumber"
                        render={({ field }) => (
                          <PhoneInput
                            {...field}
                            country={"th"}
                            value={field.value}
                            onChange={(value, { dialCode }) => {
                              setValue("countryCode", dialCode);
                              field.onChange(value);
                            }}
                          />
                        )}
                      />
                      {errors?.mobileNumber && (
                        <p className="text-danger">
                          {errors.mobileNumber.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageHotel.email")}</label>
                      <input
                        type="email"
                        className="form-control"
                        {...register("email")}
                      />
                      {errors?.email && (
                        <p className="text-danger">{errors.email.message}</p>
                      )}
                    </Col>
                    {/* <Col lg="6" className="my-2">
                      <label>{t("manageHotel.checkInTime")}</label>
                      <input
                        type="time"
                        className="form-control"
                        {...register("checkInTime")}
                      />
                      {errors?.checkInTime && (
                        <p className="text-danger">
                          {errors.checkInTime.message}
                        </p>
                      )}
                    </Col> */}

                    {/* <Col lg="6" className="my-2">
                      <label>{t("manageHotel.checkOutTime")}</label>
                      <input
                        type="time"
                        className="form-control"
                        {...register("checkOutTime")}
                      />
                      {errors?.checkOutTime && (
                        <p className="text-danger">
                          {errors.checkOutTime.message}
                        </p>
                      )}
                    </Col> */}
                    {/* <Col lg="12" className=" d-flex align-items-start gap-2">
                      <Col lg="6" className="my-2">
                        <label>
                          {t("manageHotel.columns.displayType")}
                        </label>
                        <select
                          className="form-control"
                          {...register("type", {
                            required: "Please select Type",
                          })}
                        >
                          <option value="">Select Display Type</option>
                          <option value="day">Day</option>
                        </select>

                        {errors?.type && (
                          <p className="text-danger">
                            {errors.type.message}
                          </p>
                        )}
                      </Col>
                      <Col lg="6" className="my-2">
                        <label>{t("manageHotel.columns.displayPrice")}</label>
                        <input
                          type="number"
                          className="form-control"
                          min={0}
                          {...register("price", {
                            valueAsNumber: true,
                            min: 0,
                          })}
                          onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                          onInput={(e) => {
                            if (e.target.value < 0) e.target.value = 0;
                          }}
                        />
                        {errors?.price && (
                          <p className="text-danger">
                            {errors.price.message}
                          </p>
                        )}
                      </Col>
                    </Col> */}

                    <Col lg="6" className="my-2">
                      <label>
                        {t("manageHotel.columns.availablity")}
                      </label>
                      <select
                        className="form-control"
                        {...register("availability", {
                          required: "Please select availability",
                        })}
                      >
                        <option value="">Select Availability</option>
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                      </select>

                      {errors?.availability && (
                        <p className="text-danger">
                          {errors.availability.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="12" className="my-2">
                      <label>{t("manageHotel.description")}</label>
                      <textarea
                        className="form-control"
                        {...register("description")}
                        rows={3}
                      ></textarea>
                    </Col>


                    <Col lg="12" className="">
                      <label className="fw-semibold mb-2">{t("manageHotel.highlight")}</label>

                      {fields?.map((field, index) => {
                        const currentType = watch(`highlights.${index}.type`);

                        const label =
                          highlights?.hotelHighlight?.find((h) => h?.type === currentType)?.label;

                        return (
                          <div
                            key={field?.id}
                            className="d-flex align-items-start gap-2 mb-3"
                          >
                            {/* Select */}
                            <select
                              className="form-control"
                              {...register(`highLight.${index}.type`)}
                            >
                              <option value="">Select Highlight</option>

                              {highlights?.hotelHighlight
                                ?.filter(
                                  (option) =>
                                    !selectedTypes?.includes(option?.type) ||
                                    option?.type === currentType
                                )
                                ?.map((option) => (
                                  <option key={option?.type} value={option?.type}>
                                    {option?.label}
                                  </option>
                                ))}
                            </select>

                            {/* Text input */}
                            <input
                              type="text"
                              className="form-control"
                              placeholder={
                                currentType
                                  ? `Enter text for ${label}`
                                  : "Enter highlight text"
                              }
                              // disabled={!currentType}
                              {...register(`highLight.${index}.text`, {
                                required: currentType ? "Text is required" : false,
                              })}
                            />

                            {/* Remove */}
                            {fields?.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => remove(index)}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                        );
                      })}

                      {/* Add more */}
                      <Button
                        type="button"
                        onClick={() => append({ type: "", text: "" })}
                      >
                        + {t("manageHotel.columns.addHighlight")} 
                      </Button>
                    </Col>

                    <Col lg="12" className="my-2">
                      <label className="fw-semibold">
                        {t("manageHotel.hotelAmenities")}
                      </label>
                      <div
                        className="d-flex flex-wrap gap-3 p-2 border rounded"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {hotelAmenities?.length > 0
                          ? hotelAmenities.map((amenity) => (
                            <div
                              key={amenity._id}
                              className="d-flex align-items-center"
                              style={{ minWidth: "150px" }}
                            >
                              <Form.Check
                                type="checkbox"
                                label={amenity.name}
                                checked={watch("amenities")?.includes(
                                  amenity._id
                                )}
                                onChange={(e) =>
                                  handleCheckbox(
                                    "amenities",
                                    amenity._id,
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          ))
                          : Array.from({ length: 6 }).map((_, idx) => (
                            <div
                              key={idx}
                              className="d-flex align-items-center"
                              style={{ minWidth: "150px" }}
                            >
                              <Placeholder
                                as="div"
                                animation="glow"
                                className="w-100"
                              >
                                <Placeholder xs={8} bg="primary" />
                              </Placeholder>
                            </div>
                          ))}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label className="form-label fw-bold text-muted ps-2 m-0">
                          {t("manageHotel.uploadImages")}:
                        </label>

                        <div
                          className="border border-2 border-dashed rounded d-flex flex-column align-items-center justify-content-center p-4 bg-light"
                          style={{ cursor: "pointer", minHeight: "140px" }}
                          onClick={() =>
                            document.getElementById("imageUploadInput").click()
                          }
                        >
                          <i className="bi bi-cloud-upload fs-1 text-muted"></i>
                          <p className="m-0 text-muted">
                            {t("manageHotel.columns.clickOrDrag")}
                          </p>
                          <input
                            id="imageUploadInput"
                            type="file"
                            accept="image/*"
                            multiple
                            className="d-none"
                            onChange={handleImageChange}
                          />
                        </div>

                        {errors?.hotelImages && (
                          <p className="text-danger m-0 mt-1">
                            {errors.hotelImages.message}
                          </p>
                        )}

                        <div className="d-flex flex-wrap gap-2 mt-3">
                          {imgloader ? (
                            <div
                              style={{ height: 120, width: 120 }}
                              className="d-flex align-items-center justify-content-center border rounded"
                            >
                              Loading...
                            </div>
                          ) : (
                            imagePreviews.map((img, index) => (
                              <div
                                key={img._id}
                                style={{ width: 120, height: 120, position: "relative" }}
                                className="border rounded overflow-hidden shadow-sm"
                              >
                                <img
                                  src={img.link}
                                  alt={`preview-${index}`}
                                  className="w-100 h-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                                  onClick={() => handleRemoveImage(index)}
                                >
                                  ✕
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </Col>

                  { id&& <Col lg="12" className="my-3">
                      <div className="d-flex align-items-center gap-3 px-4">
                        <Form.Check
                          type="switch"
                          id="status-switch"
                          label={t("Status")}
                          {...register("status")}
                          style={{ transform: "scale(1.4)", cursor: "pointer" }}
                          className="form-switch-success"
                        />
                      </div>
                    </Col>}

                    <Col
                      lg="12"
                      className="my-3 d-flex justify-content-between"
                    >
                      <Link to={`/hotel?page=${page}`}>
                        <Button variant="secondary">
                          {t("manageHotel.columns.back")}
                        </Button>
                      </Link>
                      <Button type="submit" variant="primary">
                        {id
                          ? t("manageHotel.columns.update")
                          : t("manageHotel.columns.submit")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddEditHotel;
